import { Portal } from "@radix-ui/themes";
import { Vector2d } from "konva/lib/types";
import { useState } from "react";
import Animal from "react-animals";
import { twMerge } from "tailwind-merge";

type ZoomableAnimalProps = {
  zoomScale?: number;
  size: string;
  animal: string;
  color: string;
};

export function ZoomableAnimal({
  zoomScale,
  size,
  animal,
  color,
}: ZoomableAnimalProps) {
  const [hovered, setHovered] = useState(false);
  const [coord, setCoord] = useState<Vector2d | null>(null);

  const onPointerEnter = (e: React.PointerEvent<HTMLDivElement>) => {
    const rect = e.currentTarget.getBoundingClientRect();

    setCoord({
      x: rect.x,
      y: rect.y,
    });
    setHovered(true);
  };

  const onPointerLeave = () => {
    setHovered(false);
    setCoord(null);
  };

  return (
    <div
      className="relative py-1"
      onPointerEnter={onPointerEnter}
      onPointerLeave={onPointerLeave}
    >
      {hovered && (
        <Portal>
          <div
            style={
              {
                "--scale": zoomScale,
                left: coord?.x,
                top: coord?.y,
              } as React.CSSProperties
            }
            className={twMerge([
              "scale-[var(--scale)] fixed z-[100] pointer-events-none",
            ])}
          >
            <Animal circle size={size} name={animal} color={color} />
          </div>
        </Portal>
      )}
      <Animal circle size={size} name={animal} color={color} />
    </div>
  );
}
